import React, { useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import ChangeBgIcon from '@wix/da-ds/pkg/Icons/24x24/ChangeBg';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarEditButton from '../../_partials/items/ActionBarEditButton';
import { BiData, ChangeBackgroundClickBiEvent } from '@wix/da-bi/pkg/events';

export interface Props {
  deviation: PapiDeviation;
  currentBackgroundId?: number;
  isBackgroundsPopupOpen: boolean;
  onInitialize: () => void;
  showBackgroundPicker: (deviation: PapiDeviation) => void;
}

const EditBackgroundButton: React.FC<React.PropsWithChildren<Props>> = ({
  deviation,
  currentBackgroundId,
  onInitialize,
  showBackgroundPicker,
  isBackgroundsPopupOpen,
}) => {
  const { t } = useTranslation();
  useEffect(() => {
    onInitialize();
  }, [onInitialize]);

  const onClick = useCallback(() => {
    if (isBackgroundsPopupOpen) {
      return;
    }
    showBackgroundPicker(deviation);
  }, [deviation, isBackgroundsPopupOpen, showBackgroundPicker]);

  return (
    <ActionBarItemWrapper tooltip={t('deviation.backgrounds.change')}>
      <ActionBarEditButton
        onClick={onClick}
        biData={BiData<ChangeBackgroundClickBiEvent>({
          evid: 370,
          itemid: deviation.deviationId,
          typeid: getDeviationResourceType(deviation),
          background_id: currentBackgroundId,
          core_only: deviation.background?.isPremium ? 1 : 0,
        })}
      >
        <ActionBarIcon icon={ChangeBgIcon} />
      </ActionBarEditButton>
    </ActionBarItemWrapper>
  );
};
EditBackgroundButton.displayName = 'EditBackgroundButton';

export default EditBackgroundButton;
